import { textAnimations } from './utils/text-animations';

export default function () {
    // -------------------------------------
    // Texts animations
    // -------------------------------------
    textAnimations();
}
